import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-wrap justify-between gap-1'
  },
  variants: {},
  defaultVariants: {}
});
